import React, {FC, useEffect, useMemo, useRef, useState} from 'react'
import {getApiErrorMessage, isApiPayloadSuccess, KTSVG} from 'src/marketConnect/helpers'
import AlertModal from 'src/utils/modals/AlertModal'
import ConnectPlatformStrip from './components/ConnectPlatformStrip'
import ConnectPlatformModal from './components/ConnectPlatformModal'
import {useAppDispatch, useAppSelector} from 'src/redux/storeHooks'
import Spinner from 'react-bootstrap/Spinner'
import Loader from 'src/utils/Loader'

import {
  connectPlatformAsync,
  createPlatformSettingAsync,
  deletePlatformDataAsync,
  fetchConnectedPlatformAsync,
  getAllPlatformTypesAsync,
  retrivePlatformDataAsync,
  shopifyappUninstallAsync,
} from 'src/redux/actions/platformActions'
import {
  Platform,
  PlatformDataType,
  PlatformSettingsDataType,
  connectedPlatformPayload,
} from 'src/interfaces/Platform.interface'
import {toast} from 'react-toastify'
import ConnectPlatformStrip1 from './components/ConnectPlatformStrip1'
import {Link, Navigate, useNavigate, useParams, useSearchParams} from 'react-router-dom'
import { isActiveBoolean } from 'src/redux/actions/changeisActiveAction'
import { getApproveSubscriptionAsync, getUserPlanAsync } from 'src/redux/actions/pricingActions'
import useAppToast from 'src/hooks/useAppToast'
import CommonAlertModal from 'src/utils/modals/CommonAlertModal'
import { setShopifyConnectFirstTimeMessageShow } from 'src/redux/slices/authSlice'
import { getInitialSyncStatusAsync, handleOauthForConnectPlatformAsync, refreshOauthForConnectPlatformAsync } from 'src/redux/actions/authActions'
import { setStepsData } from 'src/redux/slices/tourPopupSlice'
import { accessSessionTokenKeyName, refreshOauthTokenData, shopifyDetailsForOauth } from 'src/utils/constants'
import {
  rememberImpersonationReturnPath,
  resolveOAuthWindowTarget,
} from 'src/utils/impersonationTokens'
import { fetchUserAccountDetailsAsync } from 'src/redux/actions/accountActions'
import {isSecondaryConnectedPlatform} from 'src/utils/platformConnectionValidation'

const isWooCommerceOAuthSuccess = (value: string | null) =>
  value === '1' || `${value ?? ''}`.toLowerCase() === 'true'

const resolveWooCommerceConnectedPlatform = (
  platforms: any[] = [],
  oauthContext: Record<string, any> | null
) => {
  const wooPlatforms = platforms.filter(
    (platform) => `${platform?.name ?? platform?.code ?? ''}`.toUpperCase() === 'WOOCOMMERCE'
  )
  if (!wooPlatforms.length) return null

  const platformId = oauthContext?.platform_id
  if (platformId !== undefined && platformId !== null) {
    const matchedById = wooPlatforms.find((platform) => platform.id === platformId)
    if (matchedById) return matchedById
  }

  const friendlyName = oauthContext?.friendlyName
  if (friendlyName) {
    const matchedByName = wooPlatforms.find((platform) => platform.display_name === friendlyName)
    if (matchedByName) return matchedByName
  }

  return wooPlatforms.reduce((latest, current) => (current.id > latest.id ? current : latest))
}

const wasConnectedAsSecondaryFromOauthContext = (oauthContext: Record<string, any> | null) =>
  Boolean(
    oauthContext &&
      !oauthContext.isMainStore &&
      !oauthContext.isAccountingStore &&
      !oauthContext.isShippingStore &&
      !oauthContext.isErpStore &&
      !oauthContext.isOmsStore &&
      !oauthContext.isTicketStore
  )

type PlatformsProps = {
  nature?: string;
  search?: string;
};
const isTicketPlatform = (platform: any) =>
  platform?.isTicketStore === true ||
  [
    platform?.platform_info?.nature,
    platform?.nature,
    platform?.platform_info?.type,
    platform?.type,
    platform?.code,
    platform?.name,
    platform?.display_name,
    platform?.platform_info?.name,
    platform?.platform_info?.display_name,
  ].some((value) => {
    const normalizedValue = `${value ?? ''}`.toUpperCase()
    return (
      normalizedValue.includes('TICKET') ||
      normalizedValue.includes('HELPDESK') ||
      normalizedValue.includes('HELP_DESK') ||
      normalizedValue.includes('HELP DESK')
    )
  })

const isRolePlatform = (platform: any) =>
  platform?.isMainStore === true ||
  platform?.isAccountingStore === true ||
  platform?.isShippingStore === true ||
  platform?.isErpStore === true ||
  platform?.isOmsStore === true ||
  isTicketPlatform(platform)

const ConnectedPlatforms: FC<PlatformsProps> = ({nature, search}) => {
  const navigate = useNavigate();
  const [showAlertModal, setShowAlertModal] = useState<boolean>(false)
  const [deleting, setDeleting] = useState(false)
  const [selectedPlatformDelete, setSelectedPlatformDelete] = useState<PlatformDataType>()

  const [deletionCompleted, setDeletionCompleted] = useState<boolean>(false) // New state variable
  const {fetchedConnectedPlatformData, fetchedConnectedPlatformLoading, mainStoreData} = useAppSelector((state) => state.fetchConnectedPlatform)
  const { userCurrentSubscription, requestSubscriptionLoading} = useAppSelector((state) => state.pricing)
  const {connectedPlatformData,platformSettingModalData } = useAppSelector((state) => state.connectedPlatform)
  const {successToast, errorToast, warningToast} = useAppToast()
  const {selectedPlatformId} = useParams()
  const [searchParams, setSearchParams] = useSearchParams();
  const charge_id= searchParams.get("charge_id") 
  const contract_id = searchParams.get('contract_id')
  const billing_intent_id = searchParams.get('billing_intent_id')
  const success = searchParams.get('success')
  const userId = searchParams.get('user_id')
  const subscription = searchParams.get('subscription')
  const subscriptionError = searchParams.get('error')
  const [isRefreshing, setIsRefreshing] = useState(false)
  const { stepsData } = useAppSelector(state=>state.tourPopup)
   const [connectedPlatformsTypewise, setConnectedPlatformsTypewise] = useState<string[]>([]);
  const [isVisibleAlertModel, setIsVisibleAlertModel] =useState<boolean>(false)
  const { fetchedUserAccountData } = useAppSelector(state=>state.userAccountData)
  const { platformData } = useAppSelector((state) => state.platform)
  const dispatch = useAppDispatch()
  const wooOAuthRedirectHandled = useRef(false)
  const [showConnectPlatformModal, setShowConnectPlatformModal] = useState<boolean>(false)
  const [selectedPlatformForReauth, setSelectedPlatformForReauth] = useState<Platform | null>(null)
  const [selectedConnectedPlatformForReauth, setSelectedConnectedPlatformForReauth] = useState<any>(
    null
  )
  const reauthInitialValues = useMemo<Record<string, any> | undefined>(() => {
    if (!selectedConnectedPlatformForReauth) return undefined
    const credentials = selectedConnectedPlatformForReauth?.credentials ?? {}
    const maskedCredentialKeys = new Set([
      'client_id',
      'client_secret',
      'token_id',
      'token_secret',
      'refresh_token',
      'application_id',
    ])
    const normalizedCredentials = Object.keys(credentials).reduce((acc, key) => {
      acc[key] = maskedCredentialKeys.has(key) ? '' : credentials[key] ?? ''
      return acc
    }, {} as Record<string, any>)
    const accountModeValue =
      credentials.account_mode ?? credentials.mode ?? normalizedCredentials.account_mode ?? 'LIVE'
    const isEbay = (selectedConnectedPlatformForReauth?.name ?? '').toUpperCase() === 'EBAY'
    const countryValue =
      normalizedCredentials.country || selectedConnectedPlatformForReauth?.country || ''
    const countryIsoValue = isEbay
      ? normalizedCredentials.country_iso ||
        normalizedCredentials.country ||
        selectedConnectedPlatformForReauth?.country ||
        ''
      : normalizedCredentials.country_iso ||
        normalizedCredentials.country ||
        selectedConnectedPlatformForReauth?.country ||
        ''
    const currencyValue =
      normalizedCredentials.currency || selectedConnectedPlatformForReauth?.currency_iso || ''
    return {
      ...normalizedCredentials,
      friendlyName: selectedConnectedPlatformForReauth?.display_name || '',
      country: isEbay ? '' : countryValue,
      country_iso: countryIsoValue,
      currency: isEbay ? '' : currencyValue,
      account_mode: accountModeValue,
      mode: accountModeValue,
    }
  }, [selectedConnectedPlatformForReauth])

  const handleReauthConnect = (
    dataCollector: any,
    friendlyName: string,
    connection_type?: string,
    extras?: Record<string, any>
  ) => {
    const platform = selectedPlatformForReauth
    const existing = selectedConnectedPlatformForReauth
    if (!platform || !existing) {
      closeReauthConnectModal()
      return
    }

    const findCredentialValue = (name: string) => {
      const normalized = name?.toLowerCase()
      const matched = Array.isArray(dataCollector)
        ? dataCollector.find((item) => (item?.name ?? '').toLowerCase() === normalized)
        : undefined
      return matched?.value ?? null
    }

    const accountModeValue = extras?.account_mode ?? extras?.mode ?? findCredentialValue('account_mode')

    const isEbay = (platform.name ?? '').toUpperCase() === 'EBAY'

    const payload: connectedPlatformPayload = {
      id: existing?.id,
      platform_id: existing?.id,
      name: platform.name,
      type: platform.type,
      code: platform.name,
      display_name: friendlyName || existing?.display_name || platform.display_name,
      platform_info: platform.id,
      credentials: {
        identifier: findCredentialValue('identifier'),
        client_id: findCredentialValue('client_id'),
        client_secret: findCredentialValue('client_secret'),
        token_id: findCredentialValue('token_id'),
        token_secret: findCredentialValue('token_secret'),
        refresh_token: null,
        sftp_hostname: findCredentialValue('sftp_hostname'),
        sftp_username: findCredentialValue('sftp_username'),
        sftp_password: findCredentialValue('sftp_password'),
        country: isEbay ? '' : findCredentialValue('country') || '',
        country_code: isEbay ? '' : findCredentialValue('country_code') || '',
        country_iso: isEbay
          ? extras?.country_iso || findCredentialValue('country_iso') || ''
          : extras?.country_iso || findCredentialValue('country_iso') || findCredentialValue('country') || '',
        proxies: findCredentialValue('proxies') || '',
        mode: accountModeValue || '',
        currency: isEbay ? '' : extras?.currency || findCredentialValue('currency') || existing?.currency_iso || '',
        expiry_at: findCredentialValue('expiry_at') || '',
        country_region: findCredentialValue('country_region') || '',
        application_id: findCredentialValue('application_id') || '',
        version: findCredentialValue('version') || '',
        connection_type: connection_type || 'api_key',
      },
      isConnected: true,
      isActive: true,
      isMainStore: existing?.isMainStore ?? false,
      isAccountingStore: existing?.isAccountingStore ?? false,
      isShippingStore: existing?.isShippingStore ?? false,
      isErpStore: existing?.isErpStore ?? false,
      isTicketStore: existing?.isTicketStore ?? isTicketPlatform(platform),
      isOrderSyncProcessing: false,
      isNewOrderSyncProcessing: false,
      isOrderCreateProcessing: false,
    }

    if (accountModeValue) {
      ;(payload as any).account_mode = accountModeValue
    }

    closeReauthConnectModal()
    dispatch(connectPlatformAsync(payload))
      .then((response: any) => {
        dispatch(fetchConnectedPlatformAsync())
        if (response.meta.requestStatus === 'fulfilled') {
          successToast(`Platform ${payload.name} reconnected successfully!`)
        } else {
          errorToast('Failed to reconnect channel.')
        }
      })
      .catch(() => {
        errorToast('Failed to reconnect channel.')
      })
  }

  const sendSubscriptionLog = async (entry: Record<string, any>) => {
    try {
      const token = localStorage.getItem(accessSessionTokenKeyName)
      await fetch(`${process.env.REACT_APP_API_URL}/api/subscription-log`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          ...(token ? {Authorization: `Bearer ${token}`} : {}),
        },
        body: JSON.stringify(entry),
      })
    } catch (err) {
      console.warn('Unable to persist PayPal redirect log to server', err)
    }
  }

  const logPaypalQueryParams = (params: Record<string, any>) => {
    try {
      console.log('[PayPal Redirect Params]', params)
      localStorage.setItem(
        'paypal_redirect_debug',
        JSON.stringify({params, timestamp: new Date().toISOString()})
      )
    } catch (err) {
      console.warn('Unable to persist PayPal redirect params', err)
    }
    sendSubscriptionLog({
      source: 'paypal_redirect',
      path: window.location.pathname,
      search: window.location.search,
      params,
      timestamp: new Date().toISOString(),
    })
  }

  useEffect(() => {
    if (subscription === 'SUCCESS') {
      setIsVisibleAlertModel(true)
      return
    }

    if (subscription === 'ERROR') {
      const message = subscriptionError ? subscriptionError.replace(/\+/g, ' ') : 'Subscription failed'
      try {
        errorToast(decodeURIComponent(message))
      } catch {
        errorToast(message)
      }
    }
  }, [subscription, subscriptionError])

  useEffect(() => {
    if (wooOAuthRedirectHandled.current) return
    if (!isWooCommerceOAuthSuccess(success) || !userId) return

    wooOAuthRedirectHandled.current = true

    let oauthContext: Record<string, any> | null = null
    try {
      const storedContext = localStorage.getItem(shopifyDetailsForOauth)
      if (storedContext) oauthContext = JSON.parse(storedContext)
    } catch {
      oauthContext = null
    }

    const clearWooOAuthQueryParams = () => {
      const nextParams = new URLSearchParams(searchParams)
      nextParams.delete('success')
      nextParams.delete('user_id')
      setSearchParams(nextParams, {replace: true})
      localStorage.removeItem(shopifyDetailsForOauth)
    }

    const openChannelSettingsAfterConnect = (connectedPlatform: any) => {
      const {id, name, platform_info} = connectedPlatform
      localStorage.setItem(`platformFirstConnect_${name}_${id.toString()}`, 'true')
      successToast('Channel Connected Successfully')
      dispatch(getInitialSyncStatusAsync({platform_id: id}))
      navigate(`/channel-settings/${platform_info?.id}/${id}`)
    }

    dispatch(fetchConnectedPlatformAsync())
      .then((response: any) => {
        const platforms = response?.payload?.data ?? fetchedConnectedPlatformData ?? []
        const connectedPlatform = resolveWooCommerceConnectedPlatform(platforms, oauthContext)
        clearWooOAuthQueryParams()

        if (!connectedPlatform) {
          setIsVisibleAlertModel(true)
          return
        }

        if (
          isSecondaryConnectedPlatform(connectedPlatform) ||
          wasConnectedAsSecondaryFromOauthContext(oauthContext)
        ) {
          openChannelSettingsAfterConnect(connectedPlatform)
          return
        }

        if (fetchedUserAccountData?.source === 'WOOCOMMERCE') {
          setIsVisibleAlertModel(true)
          return
        }

        openChannelSettingsAfterConnect(connectedPlatform)
      })
      .catch(() => {
        clearWooOAuthQueryParams()
        setIsVisibleAlertModel(true)
      })
  }, [
    success,
    userId,
    dispatch,
    navigate,
    searchParams,
    setSearchParams,
    successToast,
    fetchedConnectedPlatformData,
    fetchedUserAccountData?.source,
  ])

  useEffect(() => {
    dispatch(setStepsData({stepData:stepsData,visible:true}))
    if(window.location.search){
      let queryItems = window.location.search.slice(1,window.location.search.length).split('&')
      let params = {}
      for(let ser of queryItems){
        let keyval = ser.split('=')
        params[keyval[0]] = keyval[1]
      }
      const isPaypalRedirect = !!(params['subscription_id'] || params['ba_token'] || params['token'])
      if (isPaypalRedirect && !selectedPlatformId && params['platform_id']) {
        const search = new URLSearchParams(params)
        const platformIdFromQuery = params['platform_id']
        search.delete('platform_id')
        const qs = search.toString()
        navigate(
          `/listing-channels/${platformIdFromQuery}${qs ? `?${qs}` : ''}`,
          {replace: true}
        )
        return
      }
      params['platform_id'] = selectedPlatformId ?? params['platform_id'] ?? null
      logPaypalQueryParams(params)
      if(!params['platform_id']){
        console.warn('PayPal redirect missing platform_id; approve-subscription may fail')
      }
      if(!success){
        // Subscription approval is handled by backend redirect now; no need to call approve-subscription.
        // dispatch(getApproveSubscriptionAsync({...params}))
        // .then((response)=>{
        //   if (response?.payload?.status_code === 201 && response?.payload?.data) {
        //     successToast(response?.payload?.message)
        //     setIsVisibleAlertModel(true)
        //     if(response?.payload?.data?.is_subscribed=='true'){
        //       dispatch(setStepsData({stepData:stepsData,visible:true}))
        //     }
        //  }else{
        //   errorToast(response?.payload?.massage)
        //   setIsVisibleAlertModel(false)
        //  }
        // })  // Dispatch the action with charge_id
     } 
    }
    
    // if ( contract_id && billing_intent_id) {
    //   let queryData = {
    //     contract_id:contract_id, 
    //     billing_intent_id: billing_intent_id,
    //     platform_id:'',
    //     charge_id:'' 
    //   }

    //   if(selectedPlatform){
    //     queryData['platform_id'] = selectedPlatformId+''
    //   }
    //   if(charge_id){
    //     queryData['charge_id'] = charge_id
    //   }
    //   // dispatch(getApproveSubscriptionAsync({...queryData}))
    //   // .then((response)=>{
    //   //   if (response?.payload?.status_code === 201 && response?.payload?.data) {
    //   //     successToast(response?.payload?.message)
    //   //     dispatch(getUserPlanAsync()).then((response) => {
    //   //       console.log('list of  userplan', response)
    //   //     })
    //   //  }else{
    //   //   errorToast(response?.payload?.massage)
    //   //   dispatch(getUserPlanAsync()).then((response) => {
    //   //     console.log('list of  userplan', response)
    //   //   })
    //   //  }
    //   // })  // Dispatch the action with charge_id
    //   // setIsVisibleAlertModel(true)
    // }
  }, [charge_id])

  
  const onDeleteStripe = (platform: PlatformDataType) => {
    setSelectedPlatformDelete(platform)
    setShowAlertModal(true)
  }

  const handleRefreshForPlatform = (platform: any) => {
    setIsRefreshing(true)
    const payload = {
      available_platform_name: platform?.name,
      platform_id: platform?.id,
      isRefresh: true,
    }

    const refreshPromise =
      platform?.code === 'ETSY'
        ? dispatch(handleOauthForConnectPlatformAsync(payload))
        : dispatch(refreshOauthForConnectPlatformAsync(payload))

    refreshPromise
      .then((response: any) => {
        localStorage.setItem(
          refreshOauthTokenData,
          JSON.stringify({
            available_platform_name: platform?.name,
            user_id: fetchedUserAccountData?.id,
          })
        )
        rememberImpersonationReturnPath()
        window.open(response.payload?.data?.url, resolveOAuthWindowTarget(platform?.code))
        setTimeout(() => {
          setIsRefreshing(false)
        }, 4000)
      })
      .catch(() => {
        setIsRefreshing(false)
      })
  }

  const handleReauthForPlatform = (platform: any) => {
    const platformCode = (platform?.code ?? '').toUpperCase()
    const isEbay = platformCode === 'EBAY'
    const isOauthPlatform = platform?.platform_info?.isOauth === true
    const shouldOpenReauthModal = isEbay || !isOauthPlatform

    if (shouldOpenReauthModal) {
      openReauthConnectModal(platform)
      return
    }

    setIsRefreshing(true)
    const payload = {
      available_platform_name: platform?.name,
      platform_id: platform?.id,
    }
    dispatch(handleOauthForConnectPlatformAsync({...payload}))
      .then((response) => {
        if (response.payload?.data && response.payload?.status_code === 200) {
          localStorage.setItem(
            shopifyDetailsForOauth,
            JSON.stringify({
              name: platform?.name,
              friendlyName: platform?.platform_info?.name,
              platform_id: platform?.id,
              isMainStore: !!platform?.isMainStore,
              isAccountingStore: !!platform?.isAccountingStore,
              isShippingStore: !!platform?.isShippingStore,
              isErpStore: !!platform?.isErpStore,
              isOmsStore: !!platform?.isOmsStore,
              isTicketStore: isTicketPlatform(platform),
              userId: fetchedUserAccountData?.id,
            })
          )
          rememberImpersonationReturnPath()
          setIsRefreshing(false)
          window.open(response.payload?.data?.url, resolveOAuthWindowTarget(platform?.code))
        }
        if (response.payload?.data?.status_code == 400) {
          warningToast(response.payload?.data?.data?.message)
        }
        setIsRefreshing(false)
      })
      .catch(() => {
        setIsRefreshing(false)
      })
  }

  const openReauthConnectModal = (platform: any) => {
    const platformId = platform?.platform_info?.id
    const platformCode = (platform?.code ?? '').toUpperCase()
    const matchedPlatform =
      platformData?.find((item: Platform) => {
        const itemName = (item?.name ?? '').toUpperCase()
        const itemDisplayName = (item?.display_name ?? '').toUpperCase()
        return (
          (platformId && item?.id === platformId) ||
          itemName === platformCode ||
          itemDisplayName === platformCode
        )
      }) ?? (platform?.platform_info as Platform | undefined)

    setSelectedPlatformForReauth(matchedPlatform ?? null)
    setSelectedConnectedPlatformForReauth(platform ?? null)
    setShowConnectPlatformModal(true)
  }

  const closeReauthConnectModal = () => {
    setShowConnectPlatformModal(false)
    setSelectedPlatformForReauth(null)
    setSelectedConnectedPlatformForReauth(null)
  }

 useEffect(() => {
 if (!fetchedConnectedPlatformLoading) {
    const isSecondaryChannel:any = fetchedConnectedPlatformData?.find(
      (platform) =>
        !isRolePlatform(platform)
    );

    if (isSecondaryChannel) {
      dispatch(
        getAllPlatformTypesAsync({
          platform_id: isSecondaryChannel.id.toString(),
        })
      ).then((res: any) => {
        const data = res?.payload?.data;
        const names = Array.isArray(data)
          ? data.map((item: any) => item.name)
          : [];
        setConnectedPlatformsTypewise(names);
      });
    }
  }
}, [fetchedConnectedPlatformData]);



  // useEffect(() => {
  //   if (fetchedConnectedPlatformData && !fetchedConnectedPlatformLoading && deletionCompleted) {
  //     // Check if deletion is completed and loading is false
  //     dispatch(fetchConnectedPlatformAsync())
  //     setDeletionCompleted(false) // Reset deletionCompleted state
  //   }
  // }, []) // Dependency array includes deletionCompleted

  // useEffect(() => {
  //   dispatch(fetchConnectedPlatformAsync())
  // }, [])

  // useEffect(() => {
  //  if(platformSettingModalData){
  //   setSelectedPlatform(platformSettingModalData)
  //   setShowSettingModal(true)
  //  }
  // }, [platformSettingModalData])



  const onDeleteConfirmed = async () => {
    if (!selectedPlatformDelete?.id) {
      console.error('Platform id is undefined.')
      toast.warning('Platform id is undefined.')
      return
    }

    setDeleting(true)
    try {
      const response = await dispatch(deletePlatformDataAsync({id: selectedPlatformDelete.id}))
      if (isApiPayloadSuccess(response)) {
        toast.success(getApiErrorMessage(response, 'Channel deleted successfully!'), {autoClose: 3000})
        if (fetchedUserAccountData?.source !== 'SHOPIFY') {
          const shouldPassPlatformId = !selectedPlatformDelete.isMainStore
          const initialSyncPayload = shouldPassPlatformId ? {platform_id: selectedPlatformDelete.id} : {}
          dispatch(getInitialSyncStatusAsync(initialSyncPayload))
        }
      } else {
        toast.warning(getApiErrorMessage(response, 'Channel not deleted'), {autoClose: 3000})
      }
    } finally {
      setDeleting(false)
      setShowAlertModal(false)
      await dispatch(fetchConnectedPlatformAsync())
    }
  }
 // Safe Guard: Hide OMS if it is already connected
  const displayableConnectedPlatforms = useMemo(() => {
    if (!Array.isArray(fetchedConnectedPlatformData)) return []
    return fetchedConnectedPlatformData.filter((platform: any) => {
      const isOmsPlatform = 
        //platform.isOmsStore === true || 
       // platform.type?.toUpperCase() === 'OMS' ||
        platform.name?.toUpperCase() === 'COMMERCIUMOMS' 
       //platform.display_name?.toUpperCase() === 'COMMERCIUM OMS'

      return !isOmsPlatform
    })
  }, [fetchedConnectedPlatformData])

  return (
    <>
      {/* <div>
        <div id='test1' className='p-4 pt-0 rounded'>
          <div className='d-flex justify-content-end'>
            <Link to='/platforms' className='btn btn-primary btn-sm' style={{fontSize: '14px'}}>
              Add new channel
            </Link>
          </div>
        </div>
      </div> */}

      {fetchedConnectedPlatformLoading || requestSubscriptionLoading ? (
        <div className='d-flex align-items-center justify-content-center h-100'>
          <h1>
            <Loader variant="section" />
          </h1>
        </div>
      ) : (
        <div className='py-4 pt-0 mt-8'>
          {displayableConnectedPlatforms?.length > 0 ?
          <>
          {
            displayableConnectedPlatforms.map((platform: any, index) => {
              if (isRolePlatform(platform)) {
                return (
                  <ConnectPlatformStrip1
                    key={platform.id}
                    platform={platform}
                    onDelete={() => onDeleteStripe(platform)}
                    onTokenRefresh={() => handleRefreshForPlatform(platform)}
                    handleOauth={() => handleReauthForPlatform(platform)}
                    isRefreshing={isRefreshing}
                  />
                )
              }
            })
          }

          {
            displayableConnectedPlatforms.map((platform: any, index) => {
              if (!isRolePlatform(platform)) {
                return (
                  <ConnectPlatformStrip
                    key={platform.id}
                    platform={platform}
                    onDelete={() => onDeleteStripe(platform)}
                    onTokenRefresh={() => handleRefreshForPlatform(platform)}
                    handleOauth={() => handleReauthForPlatform(platform)}
                    isRefreshing={isRefreshing}
                    connectedPlatformsTypewise={connectedPlatformsTypewise}
                  />
                )
              }
            })
          }
          </>
          : 
          <div className="alert bg-light-primary d-flex align-items-center p-5 shadow-sm">
            <span className="svg-icon svg-icon-2hx svg-icon-primary me-8">
              <KTSVG path="media/icons/duotune/communication/com009.svg" className="svg-icon-muted svg-icon-3hx" />
            </span>
          
            <div className="d-flex flex-column">
              <h5 className="mb-1">No Platform is connected yet </h5>
              <span>Please connect a platform. Click here to connect <Link to={'/dashboard'} > <KTSVG path="media/icons/duotune/general/gen016.svg" className="svg-icon-primary svg-icon-hx" /></Link>  </span>
            </div>
          </div>
          }
        </div>
      )}


      <AlertModal
        isVisible={showAlertModal}
        inProgress={deleting}
        successBtnLabel={deleting ? 'Deleting...' : 'Confirm Delete' }
        closeModal={() => setShowAlertModal(false)}
        onDeleteConfirmed={onDeleteConfirmed}
        selectedPlatformDelete={selectedPlatformDelete}
      />

      <CommonAlertModal
          title = { (success && userId) ? "WooCommerce is successfully connected" : `You have subscribed to the selected plan. Your new plan is active.` 
            // : "You have successfully subscribed to the plan. You can now proceed further."
           }
          subtitle=''
          onSuccess={() => {
            setIsVisibleAlertModel(false)
            if(fetchedUserAccountData?.source=='WOOCOMMERCE'){
              if(!fetchedConnectedPlatformData?.length){
                dispatch(setShopifyConnectFirstTimeMessageShow({show:true,message:'Go ahead & Connect WooCommerce as your Source store'}))
              }
              navigate('/dashboard')
            }else{
              dispatch(fetchUserAccountDetailsAsync())
              navigate('/listing-channels')
            }
          }}
          onCancel={() => {
            setIsVisibleAlertModel(false)
          
          }}
          cancelBtnTitle='Close'
          isVisible={isVisibleAlertModel}
          isTermsVisible={false}
          setIsVisible={() => {}}
          showCloseButton={false}
          iconPath='/media/icons/duotune/general/gen043.svg'
          iconClass="svg-icon-success svg-icon-4hx"
          successBtnClasses='btn btn-sm btn-success  m-2'
          successBtnTitle='Ok'
        />

      <ConnectPlatformModal
        isVisible={showConnectPlatformModal}
        closeModal={closeReauthConnectModal}
        data={selectedPlatformForReauth}
        initialValues={reauthInitialValues}
        existingPlatformId={selectedConnectedPlatformForReauth?.id || null}
        channelNameReadOnly={true}
        submitLabel='Re-connect'
        onDataReceived={handleReauthConnect}
        isReauth={true}
      />

     
    </>
  )
}

export default ConnectedPlatforms
